import Vue from 'vue';

export default function useRecaptcha() {
  return {
    async getRecaptchaToken(action = null) {
      await Vue.prototype.$recaptchaLoaded();

      return Vue.prototype.$recaptcha(action);
    },
  };
}
